/**
 * UI overhaul PR-1a — the most-recently-used list that decides which tabs
 * stay mounted (`LIVE_TABS` in types.ts). Pure so it can be unit-tested and
 * so TabsHost's render stays free of effects that set state.
 */

/** Move `id` to the front; keep at most `cap` entries. */
export function touchMru(list: readonly string[], id: string, cap: number): string[] {
  const next = [id]
  for (const x of list) {
    if (x !== id) next.push(x)
    if (next.length >= cap) break
  }
  return next
}

/** Drop ids that no longer exist (closed tabs) — `keep` is always retained. */
export function pruneMru(list: readonly string[], alive: ReadonlySet<string>, keep: string): string[] {
  return list.filter((id) => id === keep || alive.has(id))
}
